<template>
  <div class="sourcing-audit">
    <div>
      <p class="closeBtn icon-guanbi" @click="closePage"></p>
    </div>
    <el-form :model="sourcingLineHeadInfo" class="form_border" :label-position="labelPosition" label-width="130px" :disabled="true">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$t('quoteByLine.sourcing.sourcingNo')" prop="sourcingNo">
            <el-input class="handle-input" v-model="sourcingLineHeadInfo.sourcingNo" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="sourcingLineHeadInfo.sourcingCategory == 'PRODUCT'?$t('quote.applyNo'):$t('quoteByLine.sourcing.applyNo')" prop="applyNo">
            <el-input class="handle-input" v-model="sourcingLineHeadInfo.auotationApply.applyNo" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('quoteByLine.sourcing.subject')" prop="subject">
            <el-tooltip v-if="sourcingLineHeadInfo.auotationApply.subject.length>15" effect="dark" :content="sourcingLineHeadInfo.auotationApply.subject" placement="top-start">
              <el-input class="handle-input" v-model="sourcingLineHeadInfo.auotationApply.subject" clearable></el-input>
            </el-tooltip>
            <el-input v-else class="handle-input" v-model="sourcingLineHeadInfo.auotationApply.subject" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('common.createDate')" prop="createDate">
            <el-input class="handle-input" v-bind:value="sourcingLineHeadInfo.createDate|dateFormatFilter('YYYY-MM-DD')" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('common.createBy')" prop="createBy">
            <el-input class="handle-input" v-model="sourcingLineHeadInfo.creater" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('quoteByLine.sourcing.applyType')" prop="applyType">
            <ic-select v-model="sourcingLineHeadInfo.auotationApply.applyType" table="TT_QUOTATION_APPLY" field="APPLY_TYPE"></ic-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('quoteByLine.sourcing.quotationType')" prop="quotationType">
            <ic-select v-model="sourcingLineHeadInfo.auotationApply.quotationType" table="TT_QUOTATION_APPLY" field="QUOTATION_TYPE"></ic-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('common.rounds')" prop="roundNumber">
            <el-input class="handle-input" v-model="sourcingLineHeadInfo.roundNumber" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName">
      <el-tab-pane label="报价确认明细" name="detail">
        <el-row>
          <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="100px" class="searchForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="发货市" prop="pickupPoint">
                  <el-input class="handle-input" v-model="queryCondition.pickupPoint" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="到货仓库" prop="dcName">
                  <el-input class="handle-input" v-model="queryCondition.dcName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="线路类型" prop="lineTypeCode">
                  <ic-select v-model="queryCondition.lineTypeCode" table="TT_QUOTATION_APPLY_LINE" field="LINE_TYPE"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核状态" prop="status">
                  <ic-select clearable table="TT_SOURCING" class="handle-input" field="STATUS" v-model="queryCondition.status"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-bottom:10px">
              <el-button class="btn" size="mini" type="primary" @click="onSearch(1)">{{$t("common.search")}}</el-button>
              <el-button size="mini" type="primary" @click="resetForm()">{{$t("common.reset")}}</el-button>
            </el-row>
          </el-form>
        </el-row>
        <el-row class="action-btn-row" v-show="sourcingLine.filter(line=>{return line.canAudit}).length>0">
          <el-button class="btn" size="mini" type="primary" @click="audit('PASS')">{{$t("common.pass")}}</el-button>
          <el-button class="btn" size="mini" type="danger" @click="audit('REJECT')">{{$t("common.reject")}}</el-button>
          <el-button class="btn" size="mini" type="danger" @click="audit('STOP')">终止</el-button>
          <el-button class="btn" size="mini" type="primary" @click="onDownload">下载</el-button>
        </el-row>
        <ux-grid ref="sourcingLine" :data="sourcingLine" @selection-change="changeSelect" @sort-change='sortChange' :checkboxConfig="{checkMethod: selectable, highlight: true}" keep-source max-height="460" highlight-current-row show-overflow="tooltip">
          <ux-table-column align="center" type="checkbox" width="80" />
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.itemNo')" field="itemSequence" min-width="80"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.finalSupplier')" field="supplierName" min-width="120"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="发货市" field="pickupPoint" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="到货仓库" field="dcName" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="温区" field="temperature" min-width="80">
            <template v-slot="scope">
              {{scope.row.temperature | ic("COMMON",'TEMPERATURE')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="运输方式" field="transportaionMethod" min-width="100">
            <template v-slot="scope">
              {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="结算单位" field="unit" min-width="100">
            <template v-slot="scope">
              {{scope.row.unit | ic("COMMON",'UNIT')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="Leadtime" field="leadTime" min-width="120"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="预估年总费用" field="estimatedAnnualFee" min-width="150"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="报价(不含税)" field="price" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="线路现行价格" field="formalPrice" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="价格变化" field="changeRate" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="币种" field="currencyCode" min-width="80"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="有效开始日期" field="effectiveBeginDate" min-width="140">
            <template v-slot="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="线路类型" field="lineType" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('common.status')" field="status" min-width="80">
            <template v-slot="scope">
              {{scope.row.status|ic('TT_SOURCING','STATUS')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="备注" field="remarks" min-width="120"></ux-table-column>
        </ux-grid>
        <el-dialog title="报价确认申请" append-to-body :visible="auditDialog" @close="auditDialog = false" width="1200px" class="dialog">
          <el-form :model="auditForm" ref="ruleForm" label-width="100px">
            <el-form-item label="审批意见" prop="comments">
              <el-input type="textarea" v-model="auditForm.comments"></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="files">
              <el-upload class="upload-demo" ref="upload" :headers="header" :action="fileUploadUrl" :on-preview="handlePreview" :on-success="uploadSuccess" :on-remove="onRemoveFile" :before-remove="beforeRemove" multiple :file-list="files">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submit()">确定</el-button>
              <el-button @click="auditDialog=false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="log">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column sortable prop="operatorName" align="center" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column sortable prop="createDate" align="center" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">
              {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column sortable prop="action" align="center" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="comments" align="center" :label="$t('common.note') "></el-table-column>
          <el-table-column sortable align="center" :label="$t('common.attachment') ">
            <template slot-scope="scope">{{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              <fileList :files="scope.row.docs"></fileList>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import sourcingApi from "../../../api/line/sourcing"
import { Message } from 'element-ui'
import commonConstatns from "@/constants/commonConstants"
import fileList from "@/components/common/fileList"
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import { inputChoiceService } from "@/api/common/input-choice";

export default {
  name: "sourcingAudit",
  components: {
    IcSelect,
    fileList
  },
  data() {
    return {
      activeName: 'detail',
      sourcingLineHeadInfo: {
        auotationApply: {}
      },
      queryCondition: {
        pickupPoint: "",
        dcName: "",
        lineTypeCode: "",
        status: "",
      },
      applyTypeList: [],
      statusLists: [],
      sourcingLine: [],
      searchLists: [],
      auditLog: [],
      selectedLines: [],
      auditDialog: false,
      auditForm: {},
      fiels: [],
      uploadFiles: [],
      showProductInfo: false,
      fileUploadUrl: commonConstatns.fileUploadUrl,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      auditStatus: null,
      quotationApply: {},
      ttSourcingId: ''
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    closePage() {
      this.$router.push('/mytask')
    },
    sortChange(column) {
      console.log('当前列需要排序的数据', column.prop);
      console.log('当前列的排序规则', column.order);
      if (column.prop === 'itemSequence') {
        this.propType = column.prop
        if (column.order === 'descending') {
          this.sourcingLine.sort(this.descSort)
        } else if (column.order === 'ascending') {
          this.sourcingLine.sort(this.ascSort)
        }
      }
    },
    // 正序
    descSort(a, b) {
      return b[this.propType] - a[this.propType]
    },
    // 倒序
    ascSort(a, b) {
      console.log('a', a[this.propType]);
      console.log('b', b[this.propType]);
      return Number(a[this.propType]) - Number(b[this.propType])
    },
    queryData() {
      let ttSourcingId = this.$route.query.sourcingId;
      return sourcingApi.souringToAudit(ttSourcingId).then(resp => {
        this.sourcingLineHeadInfo = resp.data;
        this.auditLog = resp.data.logs;
        this.quotationApply = resp.data.quotationApply;
        this.ttSourcingId = resp.data.ttSourcingId
        switch (this.sourcingLineHeadInfo.sourcingCategory) {
          case "LINE":
            this.searchLists = resp.data.sourcingLines;
            this.sourcingLine = resp.data.sourcingLines;
            this.$refs.sourcingLine.reloadData(resp.data.sourcingLines)
            break;
          case "PRODUCT":
            this.searchLists = resp.data.sourcingProducts;
            this.sourcingLine = resp.data.sourcingProducts;
            this.$refs.sourcingLine.reloadData(resp.data.sourcingProducts)
            if (commonFun.isNotEmpty(resp.data.sourcingProducts)) {
              this.showProductInfo = commonFun.isNotEmpty(resp.data.sourcingProducts[0].externalPackagingLength);
            }
            break;
        }
        console.log('sourcingLineHeadInfo:', this.sourcingLineHeadInfo);
      })
    },
    onSearch() {
      if (this.searchLists.length > 0) {
        this.sourcingLine = this.searchLists
      }
      var originalArr = []
      if (!this.queryCondition.pickupPoint && !this.queryCondition.dcName && !this.queryCondition.lineTypeCode && !this.queryCondition.status) {
        originalArr = this.searchLists
      } else {
        let tempForm = {}
        for (var key in this.queryCondition) {
          if (typeof (this.queryCondition[key])) {
            tempForm[key] = this.queryCondition[key]
          }
        }
        // console.log('tempForm', tempForm);
        originalArr = this.sourcingLine.filter(item => {
          // console.log('item', item);
          let flag = false;
          for (key in tempForm) {
            // console.log('item[key]', item[key]);
            // console.log('tempForm[key]::::::::', tempForm[key]);
            if (!item[key]) {
              item[key] = ''
            }
            if (item[key].indexOf(tempForm[key]) >= 0) {
              // console.log('77777777777777777');
              flag = true
            } else {
              // console.log('333333333333333333');
              flag = false
              break;
            }
          }
          // console.log('55555555555555555555', flag);
          if (flag) {
            return item
          }
        })
      }
      this.sourcingLine = originalArr
    },
    resetForm() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition.status = ''
      this.onSearch()
    },
    audit(status) {
      if (commonFun.isEmpty(this.selectedLines)) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      this.auditStatus = status;
      this.auditDialog = true;
    },
    onDownload() {
      let ttSourcingId = this.$route.query.sourcingId;
      sourcingApi.onExport(ttSourcingId).then((res) => {
        fileService.respToFile(res, '线路报价确认报表-' + this.sourcingLineHeadInfo.sourcingNo + '.xlsx');
      })
    },
    changeSelect(val) {
      this.selectedLines = [];
      val.forEach((item) => {
        this.selectedLines.push(item);
      });
    },
    close() {
      router.go(-1);
    },
    submit() {
      var that = this;
      let sourcing = this.sourcingLineHeadInfo;
      let sourcingLines = this.selectedLines.map(line => {
        line.status = status;
        return line;
      });
      switch (this.sourcingLineHeadInfo.sourcingCategory) {
        case "LINE":
          sourcing.sourcingLines = sourcingLines;
          break;
        case "PRODUCT":
          sourcing.sourcingProducts = sourcingLines;
          break;
      }
      sourcing.comments = this.auditForm.comments;
      sourcing.files = this.uploadFiles;
      sourcing.status = this.auditStatus;
      sourcingApi.auditCommit(sourcing).then(resp => {
        if (resp.code != 200) {
          Message.error(resp.msg);
        } else {
          this.$refs['upload'].clearFiles();
          this.uploadFiles = [];
          that.queryData().then(() => {
            var isBack = that.sourcingLine.every(ele => {
              return !ele.canAudit
            })
            if (isBack) {
              this.$confirm('您已审批完成所有行项目,请确认是否返回所有待办任务页面?', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                that.$router.push('/mytask')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消返回'
                });
              });
            } else {
              that.auditDialog = false;
            }
            that.auditDialog = false;
          });
        }
      })
    },
    uploadSuccess(response, file, fileList) {
      this.uploadFiles = [];
      fileList.forEach(file => {
        this.uploadFiles.push(...file.response.data)
      })
    },
    onRemoveFile(file, fileList) {
      this.uploadFiles = [];
      fileList.forEach(file => {
        this.uploadFiles.push(...file.response.data)
      })
    },
    selectable({ row }) {
      return row.canAudit;
    }
  }
}
</script>
<style lang="scss">
.sourcing-audit {
  background-color: #fff;
  padding: 10px;
  // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);
  .el-input--small .el-input__inner {
    height: 34px !important;
  }
  .el-input {
    width: auto;
  }
}
</style>
